import styled from 'styled-components';

export const Wrapper = styled.div`
    margin: 5px;
`;

export const Partner = styled.div`
    width: 100%;
    height: 100%;
    border: 1px solid #f4f4f4;
    border-radius: 4px;
    position: relative;
    background-color: ${({ theme }) => theme.color.white};
    -webkit-box-shadow: 0 6px 8px 0 rgba(110,110,110,0.1);
    box-shadow: 0 6px 8px 0 rgba(110,110,110,0.1);
`

export const PartnerCover = styled.div`
    a {
        display: block;
    }
`

export const WrapCover = styled.div`
    height: 130px;
    overflow: hidden;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
`

export const Cover = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 0px none;
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;
`

export const PartnerDetails = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    position: relative;
    z-index: 1;
    margin-top: -40px;
    padding: 0.625rem;
`;

export const WrapperLogo = styled.div`
    width: 80px;
    height: 65px;
    overflow: hidden;
    padding: 5px;
    border: 1px solid ${({ theme }) => theme.color.extraLight};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.color.white};
    border-radius: 0.375rem;
`;

export const Logo = styled.img`
    width: 100%;
    height: auto;
    object-fit: cover;
    border: 0px none;
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;
`

export const Title = styled.div`
    font-size: 1rem;
    color: ${({ theme }) => theme.color.grayBold};
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    line-height: 1;
    margin-bottom: 8px;
    margin-left: 10px;
`;

export const Content = styled.div`
    /* padding: 0.625rem; */
`

export const PartnerProducts = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
    margin-bottom: 5px;
`

export const PartnerProduct = styled.div`
    display: block;
    margin-left: 10px;

    &:first-child {
        margin-left: 0;
    }


    a {
        display: block;
        height: 54px;
        width: 54px;
        border-radius: 0.25rem;
        background-color: ${({ theme }) => theme.color.gray};
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border: 0px none;
            max-width: 100%;
            display: inline-block;
            vertical-align: middle;
        }
    }
`

export const ProductImage = styled.img``

export const Button = styled.div`
    width: 100%;
    background-color: ${({ theme }) => theme.color.white};
    overflow: hidden;
    border-bottom-left-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;

    a {
        display: block;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${({ theme }) => theme.color.gray};
        height: 50px;
        padding-left: 0.9375rem;
        padding-right: 0.9375rem;
        line-height: 1;
        font-size: 0.875rem;

        svg {
            height: 13px;
            width: auto;
            position: relative;
            top: 1px;
            margin-left: 8px;

            path {
                fill: ${({ theme }) => theme.color.gray};
            }
        }
    }
`
